import { createContext } from 'react';

export const NavBarContext = createContext({
  values: new Set(),
  toggle: () => {},
});
